import { DomainEntity, Id, Json } from "@homeleite/arch";
import { EMPTY } from "@homeleite/common-utils";

export class BreedSummary implements DomainEntity {
	constructor(
		public readonly id = Id.gen(),
		public description: string = EMPTY,
		public showInApp = true
	) { }

	get name(): string {
		return this.description;
	}

	toJson(): any {
		return Json.to.simple(this);
	}

	static fromJson(json: any): BreedSummary {
		return json ? Json.from.simple(json, BreedSummary) : null;
	}
}

export class Breed implements DomainEntity {
	constructor(
		public readonly id = Id.gen(),
		public code: string = EMPTY,
		public description: string = EMPTY,
		public initial: string = EMPTY,
		public sisbovInitial: string = EMPTY,
		public showInApp = true
	) {	}

	get name(): string {
		return this.description;
	}

	toJson(): any {
		return Json.to.simple(this);
	}

	static fromJson(json: any): Breed {
		return json ? Json.from.simple(json, Breed) : null;
	}
}
